// Setup for segment tracking, snippet taken from our segment panel

/* eslint-disable */
// @ts-nocheck

export declare type Destinations = 'Intercom';

export declare type SegmentLoaderOptionsType = {
  integrations?: Record<Destinations, boolean>;
  cookie?: {
    domain?: string;
    maxAge?: number;
  };
};

export function loadSegmentLibrary(
  segmentApiKey: string,
  src: string,
  options?: SegmentLoaderOptionsType,
): void;

export const loadSegmentLibrary = function (
  segmentApiKey = 'yzZSxguu7G8stHbqCqnfaseunu62k79g',
  src = 'https://evs.segment.doxy.me/k9bq99haH1zjg1n4B2geCP/qMFhmifNpFGpb1uGjtnW15.min.js',
  loadOptions,
) {
  if (typeof window === 'undefined' || typeof window.document === 'undefined') {
    return;
  }

  var analytics = (window.analytics = window.analytics || []);

  if (!analytics.initialize)
    if (analytics.invoked)
      window.console &&
        console.error &&
        console.error('Segment snippet included twice.');
    else {
      analytics.invoked = !0;
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'screen',
        'once',
        'off',
        'on',
        'addSourceMiddleware',
        'addIntegrationMiddleware',
        'setAnonymousId',
        'addDestinationMiddleware',
        'register',
      ];
      analytics.factory = function (e) {
        return function () {
          if (window.analytics.initialized)
            return window.analytics[e].apply(window.analytics, arguments);
          var t = Array.prototype.slice.call(arguments);
          if (
            ['track', 'screen', 'alias', 'group', 'page', 'identify'].indexOf(
              e,
            ) > -1
          ) {
            var c = document.querySelector("link[rel='canonical']");
            t.push({
              __t: 'bpc',
              c: (c && c.getAttribute('href')) || void 0,
              p: location.pathname,
              u: location.href,
              s: location.search,
              t: document.title,
              r: document.referrer,
            });
          }
          t.unshift(e);
          analytics.push(t);
          return analytics;
        };
      };
      for (var e = 0; e < analytics.methods.length; e++) {
        var key = analytics.methods[e];
        analytics[key] = analytics.factory(key);
      }
      analytics.load = function (key, options) {
        var maxRetries = 3;
        var retryCount = 0;
        var retryDelay = 1000;

        var loadScript = function () {
          var t = document.createElement('script');
          t.type = 'text/javascript';
          t.async = !0;
          t.setAttribute('data-global-segment-analytics-key', 'analytics');
          t.src = analytics._src;

          t.onerror = function (error) {
            // Remove failed script tag from DOM
            if (t.parentNode) {
              t.parentNode.removeChild(t);
            }
            retryCount++;
            if (retryCount < maxRetries) {
              setTimeout(loadScript, retryDelay * retryCount);
            } else if (window.console && console.warn) {
              console.warn(
                '[analytics.js] Failed to load Analytics.js after ' +
                  maxRetries +
                  ' attempts. Analytics events will be queued but may not be sent.',
                error,
              );
            }
          };

          var target = document.head || document.body;
          if (target) {
            target.appendChild(t);
          }
          analytics._loadOptions = options;
        };

        loadScript();
      };
      analytics._src = src;
      analytics._writeKey = segmentApiKey;
      analytics._cdn = 'https://evs.segment.doxy.me';
      analytics.SNIPPET_VERSION = '5.2.0';
      analytics.load(segmentApiKey, loadOptions);
      analytics.page();
    }
};
